const wobbleRing = (r, seed) => {
  let d = "";
  const n = 56;
  for (let i = 0; i <= n; i++) {
    const a = (i / n) * Math.PI * 2;
    const rr = r * (1 + 0.035 * Math.sin(3 * a + seed) + 0.02 * Math.sin(7 * a + seed * 2));
    d += `${i ? "L" : "M"}${(rr * Math.cos(a)).toFixed(1)} ${(rr * Math.sin(a)).toFixed(1)} `;
  }
  return d + "Z";
};

export const GRAIN = [20, 38, 56, 74, 92, 110, 124].map((r, i) => wobbleRing(r, i * 1.7));

export const flamePath = (w, h, k) =>
  `M 0 0 C ${-w} ${-h * 0.22}, ${-w * 0.7} ${-h * 0.62}, ${-w * 0.15 + k} ${-h * 0.82} ` +
  `C ${-w * 0.12 + k * 0.6} ${-h * 0.66}, ${w * 0.08} ${-h * 0.6}, ${w * 0.12} ${-h * 0.46} ` +
  `C ${w * 0.4} ${-h * 0.66}, ${w * 0.18 + k} ${-h * 0.88}, ${w * 0.42 + k * 1.4} ${-h} ` +
  `C ${w * 1.05} ${-h * 0.74}, ${w * 1.1} ${-h * 0.26}, 0 0 Z`;

export const leafPath = (L, W) =>
  `M0 0 C ${L * 0.22} ${-W * 1.15}, ${L * 0.72} ${-W * 0.95}, ${L} 0 C ${L * 0.7} ${W * 0.6}, ${L * 0.28} ${W * 0.62}, 0 0 Z`;

export const Log = ({ len, r, gid, outline }) => (
  <g>
    <rect x={0} y={-r} width={len} height={r * 2} rx={8} fill={`url(#${gid}-bark)`} stroke={outline} strokeWidth={6} paintOrder="stroke" />
    <path
      d={`M14 ${-r * 0.35} L${len - 22} ${-r * 0.45} M24 ${r * 0.32} L${len - 34} ${r * 0.26} M40 ${-r * 0.05} L${len - 60} ${-r * 0.02}`}
      stroke="#7E5530" strokeOpacity="0.45" strokeWidth="2.5" strokeLinecap="round" fill="none"
    />
    <ellipse cx={len} cy={0} rx={r * 0.55 + 3} ry={r + 3} fill={outline} />
    <ellipse cx={len} cy={0} rx={r * 0.55} ry={r} fill="#EED8AA" stroke="#9A6D3F" strokeWidth={3} />
    <ellipse cx={len} cy={0} rx={r * 0.3} ry={r * 0.56} fill="none" stroke="#C49A62" strokeWidth={2} />
    <circle cx={len} cy={0} r={2.5} fill="#9A6D3F" />
  </g>
);

export const Defs = ({ id, c }) => (
  <>
    <linearGradient id={`${id}-bark`} x1="0" y1="0" x2="0" y2="1">
      <stop offset="0" stopColor="#DDB27A" />
      <stop offset="0.5" stopColor="#BC874F" />
      <stop offset="1" stopColor="#8E5D36" />
    </linearGradient>
    <linearGradient id={`${id}-flame`} x1="0" y1="1" x2="0" y2="0">
      <stop offset="0" stopColor="#B8761F" />
      <stop offset="0.55" stopColor="#DDA640" />
      <stop offset="1" stopColor="#F6DB8C" />
    </linearGradient>
    <radialGradient id={`${id}-glow`}>
      <stop offset="0" stopColor="#F6D27A" stopOpacity="0.7" />
      <stop offset="1" stopColor="#F6D27A" stopOpacity="0" />
    </radialGradient>
    <linearGradient id={`${id}-leaf`} x1="0" y1="0" x2="1" y2="0">
      <stop offset="0" stopColor="#3B7A2A" />
      <stop offset="1" stopColor="#84BC3E" />
    </linearGradient>
    <radialGradient id={`${id}-wood`}>
      <stop offset="0" stopColor="#F1DFB8" />
      <stop offset="1" stopColor="#DCBE8C" />
    </radialGradient>
    <linearGradient id={`${id}-sweep`} x1="0" y1="0" x2="1" y2="0">
      <stop offset="0" stopColor="#fff" stopOpacity="0" />
      <stop offset="0.5" stopColor="#fff" stopOpacity="0.6" />
      <stop offset="1" stopColor="#fff" stopOpacity="0" />
    </linearGradient>
    <radialGradient id={`${id}-vig`} cx="0.5" cy="0.5" r="0.75">
      <stop offset="0.55" stopColor="#000" stopOpacity="0" />
      <stop offset="1" stopColor={c.vig} stopOpacity="0.14" />
    </radialGradient>
    <filter id={`${id}-noise`} x="0" y="0" width="100%" height="100%">
      <feTurbulence type="fractalNoise" baseFrequency="0.85" numOctaves="2" stitchTiles="stitch" />
      <feColorMatrix type="saturate" values="0" />
    </filter>
    <clipPath id={`${id}-inner`}>
      <circle cx="0" cy="0" r="153" />
    </clipPath>
  </>
);

export const Paper = ({ id, c }) => (
  <g>
    <rect width="1600" height="900" fill={c.paper} />
    <rect width="1600" height="900" filter={`url(#${id}-noise)`} opacity={c.noise} />
    <rect width="1600" height="900" fill={`url(#${id}-vig)`} />
  </g>
);
